
export class SqlParam {
name: string;
type: string;
value: string;
valueType: string;
}

